import { useTranslation } from 'react-i18next';
import { useCampaignEntryCopy } from '@/i18n/campaignEntry';
import { SUPER_HERO_CAMPAIGN_ID } from '@/lib/campaigns/superHeroCampaign';

export function RankingCampaignNotice({ campaignId, campaignStatus }: {
  campaignId?: string;
  campaignStatus?: string | null;
}) {
  const { t } = useTranslation();
  const copy = useCampaignEntryCopy();
  const superHero = campaignId === SUPER_HERO_CAMPAIGN_ID;
  const startingSoon = superHero && ['draft', 'scheduled'].includes(campaignStatus || '');
  if (superHero && !startingSoon) return null;
  return <p className="rounded-md border bg-muted/40 p-3 text-sm">
    {startingSoon ? copy.previewDescription : t('ranking.privatePreview')}
  </p>;
}
